import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import ObjectObservable from "../utils/ObjectObservable";
import Button from "./Button";
import Administrator from "../models/Administrator";
import TextView from "./TextView";
import HospitalList from "./HospitalList";
import UserAdminList from "./UserAdminList";
import { BuildContext } from "../classes/BuildContext";

type _Button10OnPressed = (d3eState: HospitalTabRefs) => void;

type _Button11OnPressed = (d3eState: HospitalTabRefs) => void;

export interface HospitalTabProps extends BaseUIProps {
  key?: string;
  obj: Administrator;
}
/// To store state data for HospitalTab
class HospitalTabRefs {
  public button10: Button10State = new Button10State();
  public button11: Button11State = new Button11State();
}

interface Button11WithStateProps extends BaseUIProps {
  key?: string;
  d3eState: HospitalTabRefs;
  _onPressedButton11Handler?: _Button11OnPressed;
  selectedItem: string;
}

class Button11State extends ObjectObservable {
  private _disable: boolean = false;
  public get disable(): boolean {
    return this._disable;
  }
  public setDisable(val: boolean) {
    let isValChanged: boolean = this._disable !== val;

    if (!isValChanged) {
      return;
    }

    this._disable = val;

    this.fire("disable", this);
  }
}

class _Button11WithState extends ObservableComponent<Button11WithStateProps> {
  button11FocusNode: ui.FocusNode = new ui.FocusNode();
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: Button11WithStateProps) {
    super(props);

    this.initState();
  }
  public get button11(): Button11State {
    return this.props.d3eState.button11;
  }
  public get selectedItem(): string {
    return this.props.selectedItem;
  }
  public get d3eState(): HospitalTabRefs {
    return this.props.d3eState;
  }
  public get _onPressedButton11Handler(): _Button11OnPressed {
    return this.props._onPressedButton11Handler;
  }
  public initState() {
    super.initState();

    this.updateObservable("button11", null, this.button11);

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["button11", "selectedItem"], this.rebuild);
  }
  public dispose(): void {
    super.dispose();
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return Button({
      padding: ui.EdgeInsets.all(10.0, new Map()),
      decoration:
        this.selectedItem === "Admins"
          ? new ui.BoxDecoration({ color: cStyle.c22 })
          : new ui.BoxDecoration({ color: cStyle.c21 }),
      disable: this.button11.disable,
      onPressed: () => {
        this._onPressedButton11Handler(this.d3eState);
      },
      onFocusChange: (val) => {},
      child: TextView({
        data: "Admins",
        states: ui.joinStates({ "data-c0": this.selectedItem == "Admins" }, {}),
        style: new ui.TextStyle({
          fontFamily: "Open Sans",
          fontSize: 16,
          color: this.selectedItem == "Admins" ? cStyle.c23 : cStyle.c22,
        }),
        className: "x8a6",
      }),
    });
  }
}
function Button11WithState(props: Button11WithStateProps) {
  return React.createElement(_Button11WithState, props);
}

interface Button10WithStateProps extends BaseUIProps {
  key?: string;
  d3eState: HospitalTabRefs;
  _onPressedButton10Handler?: _Button10OnPressed;
  selectedItem: string;
}

class Button10State extends ObjectObservable {
  private _disable: boolean = false;
  public get disable(): boolean {
    return this._disable;
  }
  public setDisable(val: boolean) {
    let isValChanged: boolean = this._disable !== val;

    if (!isValChanged) {
      return;
    }

    this._disable = val;

    this.fire("disable", this);
  }
}

class _Button10WithState extends ObservableComponent<Button10WithStateProps> {
  button10FocusNode: ui.FocusNode = new ui.FocusNode();
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: Button10WithStateProps) {
    super(props);

    this.initState();
  }
  public get button10(): Button10State {
    return this.props.d3eState.button10;
  }
  public get selectedItem(): string {
    return this.props.selectedItem;
  }
  public get d3eState(): HospitalTabRefs {
    return this.props.d3eState;
  }
  public get _onPressedButton10Handler(): _Button10OnPressed {
    return this.props._onPressedButton10Handler;
  }
  public initState() {
    super.initState();

    this.updateObservable("button10", null, this.button10);

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["button10", "selectedItem"], this.rebuild);
  }
  public dispose(): void {
    super.dispose();
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Container({
      margin: ui.EdgeInsets.fromLTRB(0.0, 0.0, 10.0, 0.0, new Map()),
      child: Button({
        padding: ui.EdgeInsets.all(10.0, new Map()),
        decoration:
          this.selectedItem === "Hospital"
            ? new ui.BoxDecoration({ color: cStyle.c22 })
            : new ui.BoxDecoration({ color: cStyle.c21 }),
        disable: this.button10.disable,
        onPressed: () => {
          this._onPressedButton10Handler(this.d3eState);
        },
        onFocusChange: (val) => {},
        child: TextView({
          data: "Hospitals",
          states: ui.joinStates(
            { "data-c0": this.selectedItem === "Hospital" },
            {}
          ),
          style: new ui.TextStyle({
            fontFamily: "Open Sans",
            fontSize: 16,
            color: this.selectedItem === "Hospital" ? cStyle.c21 : cStyle.c22,
          }),
          className: "x18d",
        }),
      }),
      className: "x208",
    });
  }
}
function Button10WithState(props: Button10WithStateProps) {
  return React.createElement(_Button10WithState, props);
}

class _HospitalTabState extends ObservableComponent<HospitalTabProps> {
  static defaultProps = { obj: null };
  d3eState: HospitalTabRefs = new HospitalTabRefs();
  selectedItem: string = "Hospital";
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: HospitalTabProps) {
    super(props);

    this.initState();
  }
  public get obj(): Administrator {
    return this.props.obj;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.updateSyncProperty("obj", this.props.obj);

    this.on(["obj", "selectedItem"], this.rebuild);
  }
  public componentDidUpdate(prevProps: HospitalTabProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.obj !== this.props.obj) {
      this.updateObservable("obj", prevProps.obj, this.props.obj);

      this.fire("obj", this);
    }
  }
  public setSelectedItem(val: string): void {
    let isValChanged: boolean = this.selectedItem !== val;

    if (!isValChanged) {
      return;
    }

    this.selectedItem = val;

    this.fire("selectedItem", this);
  }
  public _cSwitchSwitch(switchValue: string): ReactNode {
    switch (switchValue) {
      case "Hospital": {
        return ui.Container({
          expand: true,
          child: HospitalList({ user: this.obj }),
          className: "xf1 hc vc h v",
        });
      }

      case "Admins": {
        return ui.Container({
          expand: true,
          child: UserAdminList({}),
          className: "xa0f hc vc h v",
        });
      }
      default: {
        return ui.Container({ className: "hc" });
      }
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        ui.Row({
          mainAxisAlignment: ui.MainAxisAlignment.start,
          children: [
            Button10WithState({
              d3eState: this.d3eState,
              _onPressedButton10Handler: this.onPressedButton10Handler,
              selectedItem: this.selectedItem,
              key: "0",
            }),
            Button11WithState({
              d3eState: this.d3eState,
              _onPressedButton11Handler: this.onPressedButton11Handler,
              selectedItem: this.selectedItem,
              key: "1",
            }),
          ],
          className: "x8da hc h",
          key: "0",
        }),
        ui.Column({
          children: [this._cSwitchSwitch(this.selectedItem)],
          className: "xb5f hc vc h v",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "HospitalTab hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onPressedButton11Handler = (d3eState: HospitalTabRefs): void => {
    this.setSelectedItem("Admins");
  };
  public onPressedButton10Handler = (d3eState: HospitalTabRefs): void => {
    this.setSelectedItem("Hospital");
  };
  public get button10() {
    return this.d3eState.button10;
  }
  public get button11() {
    return this.d3eState.button11;
  }
}
export default function HospitalTab(props: HospitalTabProps) {
  return React.createElement(_HospitalTabState, {
    ..._HospitalTabState.defaultProps,
    ...props,
  });
}
